export default __webpack_public_path__ + "static/media/internal-ticketing-system.124dbecc.svg";